// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"794c5000","802":"c153c27f"}[chunkId] + ".chunk.js";
};